import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { Otp } from '../modal/Otp';

@Injectable({
    providedIn: 'root'
})

export class ShowHiddenService {
    constructor(private httpclient: HttpClient, private global: Globals) { }

 

    GetHiddenList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getHidden/'+this.global.loggedUser.user.user_reg_id, { headers: headers });
    }
    GenerateOtp(status){
        // var status="not needed";
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<Otp>(this.global.G_apiUrl + "/approvedEmail/GenrateOtp/"+`${this.global.loggedUser.user.mobileNumber}`+`/${this.global.loggedUser.user.firstName}`+`/${status}`,{ headers:headers });
    }
   CheckOtp(otpid,otpno){
    let headers:HttpHeaders=new HttpHeaders();
    headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/approvedEmail/CheckOtp/"+`${otpid}`+`/${otpno}`,{responseType:'text', headers: headers });
    }

    CheckTransctionPassword(password){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
            return this.httpclient.get(this.global.G_apiUrl + "/approvedEmail/checkTranscationalPassword/"+`${this.global.loggedUser.user.user_reg_id}`+`/${password}`,{responseType:'text', headers: headers });
        }

   
}